module.exports = __webpack_public_path__ + "img/modal-close-blue.b7f0f309.svg";